<template>
    <div class="text-14 bg-white rounded-10 mb-4 p-2 relative">
        <div class="flex pb-1" @click="clickDetail()">
            <div class="text-a-brown-9f8273 mr-2">{{lbl.myOrder.history.order_no}}</div>
            <div class="text-a-brown-502314">{{myOrder.tranId}}</div>
        </div>
        <div class="flex pb-1" @click="clickDetail()">
            <div class="text-a-brown-9f8273 mr-2">{{lbl.myOrder.history.order_on}}</div>
            <div class="text-a-brown-502314">{{getCreateDate(myOrder.createDate)}}</div>
        </div>
        <div class="flex pb-1" @click="clickDetail()">
            <div class="text-a-brown-9f8273 mr-2">{{lbl.myOrder.history.total}}</div>
            <div class="text-a-brown-502314">{{FilterNumberFormat(myOrder.tranAmount)}} {{lbl.myOrder.history.bath}}</div>
        </div>
        <div class="flex pb-1" >
            <div class="text-a-brown-9f8273 mr-2" @click="clickDetail()">{{lbl.myOrder.history.status}}</div>
            <div :class="[getStatusClass()]" @click="clickDetail()">{{getStatusText()}}</div>
            <div class="text-a-red-d62300 ml-auto mr-0 font-bold" @click="clickReOrder()" v-if="!myOrder?.isSubscription">{{lbl.myOrder.history.reorder}}</div>
        </div>
        <div class="absolute top-2 right-2" @click="clickFav()">
            <img v-if="myOrder.isFavourite" src="@/assets/icon/ic-fav-active.svg" />
            <img v-else src="@/assets/icon/ic-fav-inactive.svg" />
        </div>
    </div>
</template>

<script>
import DatetimeHelper from "@/helper/DatetimeHelper.js";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "OrderHistoryItem",
    mixins: [LocaleMixin],
    props: {
        myOrder: { type: Object, required: true }
    },
    methods: {
        clickDetail: function() {
            this.$emit("clickDetail", this.myOrder);
        },
        clickReOrder: function() {
            this.$emit("clickReOrder", this.myOrder);
        },
        clickFav: function() {
            this.$emit("clickFav", this.myOrder);
        },
        getCreateDate: function(createDate) {
            return DatetimeHelper.timestampFullFormat(createDate) + " | " + DatetimeHelper.timeFormatShort2(createDate);
        },
        getStatusText: function () {
            if (this.myOrder.orderType == "Subscription") {
                return this.lbl.myOrder.status_ordersubscription_complete;
            } else {
                if (this.myOrder.vendorStatus == 1) {
                    return this.lbl.myOrder.statusOrderPlaced;
                } else if (this.myOrder.vendorStatus == 2) {
                    return this.lbl.myOrder.statusOnRoute;
                } else if (this.myOrder.vendorStatus == 3) {
                    return this.lbl.myOrder.statusOrderComplete;
                } else if (this.myOrder.vendorStatus == 5) {
                    return this.lbl.myOrder.statusReadyToPick;
                } else if (this.myOrder.vendorStatus == 6) {
                    return this.lbl.myOrder.statusPickedUp;
                } else if (this.myOrder.vendorStatus == -1) {
                    return this.lbl.myOrder.statusCanceled;
                } else {
                    return this.myOrder.vendorStatusName;
                }
            }
            
        },
        getStatusClass: function () {
            if (this.myOrder.orderType == "Subscription") { 
                return "text-a-green-198737";
            } else {
                if (this.myOrder.vendorStatus == 1) {
                    return "text-a-orange-ff8732";
                } else if (this.myOrder.vendorStatus == 2) {
                    return "text-a-orange-ff8732";
                } else if (this.myOrder.vendorStatus == 3) {
                    return "text-a-green-198737";
                } else if (this.myOrder.vendorStatus == 5) {
                    return "text-a-green-198737";
                } else if (this.myOrder.vendorStatus == 6) {
                    return "text-a-green-198737";
                } else if (this.myOrder.vendorStatus == -1) {
                    return "text-a-red-d62300";
                } else {
                    return "text-a-brown-502314";
                }
            }
            
        }
        
    }
}
</script>

<style>

</style>